import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'skulist',

  data() {
    return {
      skuSearchWord: '',

      sortKey: 'alert',
      sortOrder: {
        sku_id: 'asc',
        color: 'asc',
        size: 'asc',
        consumption: 'asc',
        alert: 'asc'
      }
    }
  },

  computed: {
    ...mapGetters('skulist', [
      'skulist',
      'itemId',
      'selectedSkuId'
    ]),

    /**
     * sku一覧
     * 検索単語のフィルタとソートを行う
     * item単位を表す「全て」行は固定表示
     */
    skus() {
      return _.orderBy(
        _.filter(
          this.skulist,
          sku => {
            return (
              _.includes(sku.sku_id, this.skuSearchWord) ||
              _.includes(sku.color, this.skuSearchWord) ||
              _.includes(sku.size, this.skuSearchWord) ||
              _.includes(sku.consumption.toString(), this.skuSearchWord)
            )
          }
        ),
        sku => sku[this.sortKey],
        this.sortOrder[this.sortKey]
      )
    },

    cssSearchWordEmpty() {
      return this.skuSearchWord.length === 0 ? 'nodisplay' : ''
    }
  },

  methods: {
    ...mapActions('skulist', ['setSelectedSkuId']),

    ...mapActions('detail', [
      'getDetailItem',
      'getDetailSku'
    ]),

    ...mapActions('predict', [
      'getPredictSelectItem',
      'getPredictSku'
    ]),

    /**
     * ソート変更時
     */
    changeSkuSortOption(key) {
      if (this.sortKey == key) {
        this.sortOrder[key] = this.sortOrder[key] === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
      }
    },

    /**
     * item(全て行)選択時
     * 保持するskuは空白とする
     */
    selectItem() {
      this.setSelectedSkuId('')
      this.getDetailItem({ itemId: this.itemId })
      this.getPredictSelectItem(this.itemId)
    },

    /**
     * sku選択時
     * 選択したskuはVuexに保存しておき、ページ遷移しても保持
     */
    selectSku(skuId) {
      this.setSelectedSkuId(skuId)
      this.getDetailSku({ skuId: skuId })
      this.getPredictSku(skuId)
    },

    // 動的css。ヘッダ
    cssSkuListHeader(key) {
      return {
        'sort-active': this.sortKey === key,
        'sort-isAsc': this.sortOrder[key] === 'asc'
      }
    },

    // 動的css。sku一覧の選択行
    selectRow(skuId) {
      return this.selectedSkuId === skuId ? 'sku-list__row--selected' : ''
    },

    /**
     * ページ遷移した場合、選択しているskuまでスクロール
     * カラーが全角6文字を超えると行の高さが変更になるため考慮する
     */
    scrollSku_() {
      if (this.skus.length === 0) return
      const body = document.querySelector('.sku-list__body')
      const idx = _.findIndex(this.skus, { sku_id: this.selectedSkuId })
      body.scrollTop = body.childNodes[idx + 2].offsetTop - 46
    },

    changeFocusByUpKey(filterSkus, currentIndex) {
      if (currentIndex === 0) { // データ１件目から「全て」へ移動するケース
        document.getElementById(`sku-all`).focus()
      } else {
        document.getElementById(`sku-${currentIndex - 1}`).focus()
      }
    },

    changeFocusByDownKey(filterSkus, currentIndex) {
      if (currentIndex === filterSkus.length - 1) return
      let targetIndex = currentIndex === 'all' ? 0 : currentIndex + 1
      document.getElementById(`sku-${targetIndex}`).focus()
    },

    deleteSearchWord() {
      //×アイコンにフォーカスが移ってしまうので、テキストフィールドに再フォーカス
      document.getElementsByClassName('sku-list__search-box')[0].focus()
      this.skuSearchWord = ''
    }
  },

  mounted() {
    this.scrollSku_()
  }
}



// WEBPACK FOOTER //
// ./src/components/aftersale/predict/skulist/skulist.js